// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1775808879015
      var cssReload = require("/Users/mychefkoo/Documents/cloud-dom/cloud-web/erp-flexible-web21/node_modules/@vue/cli-service/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  